import { useState, useEffect, useRef, useCallback } from "react";
import { Device } from "@twilio/voice-sdk";
import { GetRequest } from "../../Utils/hooks/ApiHandler";
import { baseURL } from "../../Utils/constants/constant";

const GlobalCallModal = ({ isOpen, onClose, phoneNumber, customerId, loginUserId, module_id, module_name }) => {
  const [device, setDevice] = useState(null);
  const [currentCall, setCurrentCall] = useState(null);
  const [status, setStatus] = useState("Initializing...");
  const [timer, setTimer] = useState(0);
  const [disabled, setDisabled] = useState(true)
  const timerInterval = useRef(null);

  // Timer functions
  const startTimer = () => {
    setTimer(0);
    timerInterval.current = setInterval(() => setTimer((prev) => prev + 1), 1000);
  };

  const stopTimer = () => {
    if (timerInterval.current) clearInterval(timerInterval.current);
  };

  const handleCallEnd = useCallback(() => {
    setStatus("Call Ended");
    setCurrentCall(null);
    stopTimer();
    // Modal automatically close after 2 seconds of call end
    setTimeout(() => {
      onClose();
    }, 2000);
  }, [onClose]);

  // Init Device
  useEffect(() => {
    if (!isOpen) return;

    const initDevice = async () => {
      try {
        const response = await GetRequest(`${baseURL}voice/token/${customerId}`, {}, {});
        const newDevice = new Device(response?.token, {
          logLevel: "error",
          edge: "ashburn",
        });

        newDevice.on("registered", () => {
          setStatus("Ready");
          // Auto dial as soon as device is ready
          makeCall(newDevice);
        });

        await newDevice.register();
        setDevice(newDevice);
      } catch (err) {
        setStatus("Setup Error");
        console.error(err);
      }
    };

    initDevice();

    return () => {
      if (device) device.destroy();
      stopTimer();
    };
  }, [isOpen]);

  const makeCall = async (activeDevice) => {
    const dev = activeDevice || device;
    if (dev && phoneNumber) {
      setStatus("Dialing...");
      try {
        const call = await dev.connect({
          params: {
            To: +918983178152, //phoneNumber,
            Record: "true",
            module_name,
            module_id,
            user_login_id: loginUserId,
            customer_id: customerId,
          },
        });
        setCurrentCall(call);

        call.on("accept", () => {
          setStatus("On Call");
          startTimer();
        });

        call.on("disconnect", handleCallEnd);
        call.on("reject", handleCallEnd);
      } catch (err) {
        setStatus("Failed");
      }
    }
  };

  const formatTime = (s) => {
    const mins = Math.floor(s / 60);
    const secs = s % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };


  useEffect(() => {
    const timer = setTimeout(() => {
      setDisabled(false)
    }, 8000)

    return () => clearTimeout(timer)
  }, [])


  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show" style={{ zIndex: 1060 }}></div>

      {/* Dialer Modal */}
      <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1065 }}>
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '350px' }}>
          <div className="modal-content border-0 shadow-lg text-white" style={{ borderRadius: '25px', background: 'rgb(187 95 147)' }}>

            <div className="modal-body text-center p-5">
              {/* Status Badge */}
              <div className="mb-3">
                <span className={`badge rounded-pill px-3 py-2 ${status === "On Call" ? "bg-danger" : "bg-primary"}`}>
                  {status}
                </span>
              </div>

              {/* Profile Image / Icon */}
              <div className="bg-secondary rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '80px', height: '80px' }}>
                <i className="bi bi-person-fill fs-1 text-light"></i>
              </div>

              {/* Number Details */}
              <span className="fw-bold mb-1"
                style={{
                  cursor: 'pointer',
                  fontFamily: "monospace",
                  letterSpacing: "1px",
                  whiteSpace: "nowrap",
                }}

              >{phoneNumber}</span>
              {/* <p className="text-secondary small">Calling via Twilio...</p> */}

              {/* Timer */}
              <h1 className="display-6 fw-bold my-4">
                {status === "On Call" ? formatTime(timer) : "0:00"}
              </h1>

              {/* Hangup Button */}
              <div className="d-flex justify-content-center mt-4">
                <button
                  disabled={disabled}
                  onClick={() => currentCall ? currentCall.disconnect() : onClose()}
                  className="btn btn-danger rounded-circle p-3 d-flex align-items-center justify-content-center shadow-lg"
                  style={{ width: '65px', height: '65px' }}
                >
                  <i className="bi bi-telephone-x-fill fs-3"></i>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalCallModal;